import { render, staticRenderFns } from "./df-section-products.vue?vue&type=template&id=511c6f36"
import script from "./df-section-products.ts?vue&type=script&lang=js&external"
export * from "./df-section-products.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports